module.exports = __webpack_public_path__ + "static/img/illustratepic_02.1d0bf32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh-CN/illustratepic_02.png
// module id = IIfu
// module chunks = 1